export default {
	'history.history': 'History',
	'history.noTask': 'No task',
};
